import React, { useEffect,useState } from "react"
import WOW from "wowjs";
import "animate.css"; // Ensure you have Animate.css for animations
import BG from '../images/bg1.png'
import Map from '../images/graph-image.png'
import bsc from '../images/bsc.png'
import waves from '../images/waves.png'
import logo from '../images/logo.png'
import {Link} from 'react-router-dom'

import Header from '../components/Header'
const Home = () => {


    useEffect(() => {
        new WOW.WOW().init();
    }, []);
    const targetDate = new Date("2025-04-30T22:00:00Z").getTime(); 
 
    return (
        <>
        <Header/>
        
            <section className="bg-secondary-100 ">
            <div className="absolute opacity-10">
                    <img src={waves} className="w-[800px] float"/>
                </div>
                <div className="h-fit py-20  px-4 md:px-6 lg:px-40">
              
                <div className="lg:my-20 py-20" >
                    
                    <div className="grid grid-cols-12" >
                        <div className="col-span-12 md:col-start-2 md:col-span-5 text-white">

                            <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInUp">
                                <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                    <i className="fa fa-check-circle text-secondary-100"></i></div>
                                <div className="font-pregular mr-5 ml-2 text-xs">
                                    100% Blockchain and decentralized
                                </div>

                            </div>

                            <h1 className="font-plight text-3xl md:text-6xl mt-10 wow animate__animated animate__fadeInUp" data--wow-delay="0.5s">
                                Blockchain Powered
                            </h1>
                            <h1 className="font-psemibold text-6xl md:text-8xl  mt-2 md:mt-2  wow animate__animated animate__fadeInUp" data--wow-delay="0.7s">
                               Mark <span className="text-primary">Man</span>
                            </h1>
                            <div className="grid grid-cols-12 mb-10">
                                <div className="p-light mt-5 col-span-9 md:col-span-9 text-gray-100 text-sm wow animate__animated animate__fadeInUp" data--wow-delay="0.8s">Step into a world where you take charge of your financial future by leveraging the power of blockchain technology
                                </div>
                            </div>

                            <Link to="/register" className="rounded-xl bg-secondary text-secondary-100 shadow px-20 py-2 text-sm font-pmedium wow animate__animated animate__fadeInUp" data--wow-delay="1s">Register/Login</Link>


                        </div>
                        <div className="col-span-12 hiddsen md:block md:col-span-5 text-white h-40 oveflow-hidden md:px-10 md:px-0">
                            <img src={Map} className="w-full float mt-10 md:mt-0" />
                        </div>
                    </div>

                </div>
                </div>
            </section>



            <section className="py-20 bg-secondary-200 px-4 md:px-6 lg:px-40"  >

                <div className="lg:my-20">
                    <div className="grid grid-cols-12">
                    <div className="col-span-12 md:col-span-4 text-white text-center flex flex-col justify-center"></div>
                        <div className="col-span-12 md:col-span-4 text-white text-center flex flex-col justify-center items-center">

                            <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInLefts">
                                <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                    <i className="fa fa-check-circle text-secondary-100"></i></div>
                                <div className="font-pmedium text-sm ml-2 pr-5">
                                    Welcome Onboard
                                </div>

                            </div>


                            <h1 className="font-psemibold text-2xl md:text-3xl mt-7 wow animate__animated animate__fadeInLefts text-center" data--wow-delay="0.2s">

                                <span className="text-primary">Mark Man</span> IS LIVE
                            </h1>
                            <Link to="/register"className="rounded-xl border border-secondary shadow bg-secondary-100 text-primary shadow mt-5 px-20 py-2 font-pmedium  wow animate__animated animate__fadeInLefts" data--wow-delay="1.2s">Register</Link>


                        </div>

                    </div>


                </div>
            </section>

         {/*    <section className="py-20 bg-secondary-200 md:px-6 lg:px-40" style={{ backgroundImage: `url(${waves})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>

                <div className="lg:py-20 flex flex-col items-center px-10">


                    <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center">
                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                            <i className="fa fa-check-circle text-secondary-100"></i></div>
                        <div className="font-pmedium text-sm ml-2 pr-5">
                            Count down to launch
                        </div>

                    </div>


                    <h1 className="font-psemibold text-center text-2xl lg:text-3xl mt-7 wow animate__animated animate__fadeInLefts text-white" data--wow-delay="0.2s">
                        Count down to <span className="text-primary">Mark Man</span> Launching
                    </h1>

                    <div className="hor-line mt-5">
                    </div>

                    

                    

                    <div className="md:flex mt-10 wow animate__animated animate__fadeInUp">
                       <div className="flex justify-center md">
                         <div className="text-center ">
                            <div class="bg-white rounded py-5 text-4xl text-cener font-psemibold h-[80px] w-[80px]">
                                {days}
                            </div>
                            <span className="text-white text-sm">Days</span>
                        </div>

                        <h3 class="text-3xl text-white px-10 mt-3">:</h3>

                        <div className="text-center">
                        <div class="bg-white rounded py-5 text-4xl text-cener font-psemibold h-[80px] w-[80px]">
                            {hours}
                            </div>
                            <span className="text-white text-sm">Hours</span>
                        </div>

                        
                        <h3 class="text-3xl text-white px-10 mt-3 hidden md:block">:</h3>

                            </div>
                        <div className="flex justify-center mt-10 md:mt-0">
                        <div className="text-center">
                        <div class="bg-white rounded py-5 text-4xl text-cener font-psemibold h-[80px] w-[80px]">
                            {minutes}
                            </div>
                            <span className="text-white text-sm">Minutes</span>
                        </div>

                        <h3 class="text-3xl text-white px-10 mt-3">:</h3>

                        <div className="text-center">
                        <div class="bg-white rounded py-5 text-4xl text-cener font-psemibold h-[80px] w-[80px]">
                            {seconds}
                            </div>
                            <span className="text-white text-sm">Seconds</span>
                        </div>

                        </div>
                    </div>





                </div>

            </section> */}

            <section className="py-20 bg-secondary-100 px-4 md:px-6 lg:px-40"  id="about" >

                <div className="lg:my-20">
                    <div className="grid grid-cols-12">

                        <div className="md:col-span-6 text-white fa-bounce hidden md:block">


                            <div class="relative w-64 h-64">
                                <div class="absolute top-0 left-0 w-full h-full  wow animate__animated animate__zoomIn">
                                    <svg width="500" height="500" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="drop-shadow-lg">
                                        <defs>
                                            <filter id="innerGlow" x="-50%" y="-50%" width="200%" height="200%">
                                                <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                                                <feComposite in="SourceGraphic" in2="blur" operator="atop" />
                                            </filter>
                                        </defs>

                                        <circle cx="100" cy="100" r="50" fill="rgba(0, 255, 255, 0.1)" filter="url(#innerGlow)" />
                                    </svg>

                                </div>

                                <div class="absolute top-0 left-0 w-full h-full  wow animate__animated animate__zoomIn" data--wow-delay="0.5s">
                                    <svg class="circle-vector spin" width="500" height="500" viewBox="0 0 424 414" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M207.565 52.9563C255.134 49.156 300.586 73.3755 331.025 110.053C362.198 147.613 379.783 197.576 366.552 244.525C353.929 289.317 310.091 313.538 268.025 333.603C226.175 353.566 180.063 371.865 137.329 353.864C92.5026 334.982 60.2927 291.463 53.7536 243.346C47.7622 199.259 78.6498 162.615 106.631 127.98C134.334 93.6895 163.57 56.4712 207.565 52.9563Z" stroke="url(#paint0_linear_11568_7928)" stroke-opacity="0.6" stroke-width="24.9412"></path>
                                        <defs>
                                            <filter id="filter0_f_11568_7928" x="0.528809" y="0.0922852" width="422.954" height="413.584" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                                <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
                                                <feGaussianBlur stdDeviation="20" result="effect1_foregroundBlur_11568_7928"></feGaussianBlur>
                                            </filter>
                                            <linearGradient id="paint0_linear_11568_7928" x1="145.692" y1="360.364" x2="189.602" y2="28.2662" gradientUnits="userSpaceOnUse">
                                                <stop offset="0" stop-color="#005ED3"></stop>
                                                <stop offset="1" stop-color="#02EBFD"></stop>
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>

                        </div>


                        
                        <div className="md:col-span-6 text-white fa-bounce md:hidden">


                            <div class="relative">
                                <div class="absolute top-0 left-0 w-full h-full  wow animate__animated animate__zoomIn">
                                    <svg width="500" height="500" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" class="drop-shadow-lg">
                                        <defs>
                                            <filter id="innerGlow" x="-50%" y="-50%" width="200%" height="200%">
                                                <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
                                                <feComposite in="SourceGraphic" in2="blur" operator="atop" />
                                            </filter>
                                        </defs>

                                        <circle cx="100" cy="100" r="50" fill="rgba(0, 255, 255, 0.1)" filter="url(#innerGlow)" />
                                    </svg>

                                </div>

                            </div>

                        </div>

                        <div className="col-span-12 md:col-span-6 text-white">

                            <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInLefts">
                                <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                    <i className="fa fa-check-circle text-secondary-100"></i></div>
                                <div className="font-pmedium text-sm ml-2 pr-5">
                                    What you need to know
                                </div>

                            </div>


                            <h1 className="font-psemibold text-2xl md:text-3xl mt-7 wow animate__animated animate__fadeInLefts" data--wow-delay="0.2s">
                                Learn More About <span className="text-primary">Mark Man</span>
                            </h1>

                            <div className="grid grid-cols-12">
                                <div className="p-light mt-5 col-span-12 md:col-span-10 text-gray-100 text-sm wow animate__animated animate__fadeInLefts" data--wow-delay="0.3s">
                                    Mark Man leverages the power of blockchain technology to create a secure and transparent environment for your earnings. Transactions are recorded on an immutable ledger, providing trust and safety. You can track your earnings in real time with full visibility into your transactions.
                                </div>
                            </div>

                            <div className="flex justify-left my-5">
                                <div className="line mr-5">
                                </div>

                                <div>

                                    <div className="mt-3 flex items-center wow animate__animated animate__fadeInLefts" data--wow-delay="0.5s">
                                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>

                                        <p className="text-white ml-3">Totally Decentralized Control</p>
                                    </div>


                                    <div className="mt-5 flex items-center wow animate__animated animate__fadeInLefts" data--wow-delay="0.7s">
                                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>

                                        <p className="text-white ml-3">Transparent Earning System</p>
                                    </div>

                                    <div className="mt-5 flex items-center wow animate__animated animate__fadeInLefts" data--wow-delay="0.9s">
                                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>

                                        <p className="text-white ml-3">100% Secured and Trustworthy</p>
                                    </div>
                                    <div className="mt-5 flex items-center wow animate__animated animate__fadeInLefts" data--wow-delay="1s">
                                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>

                                        <p className="text-white ml-3">Completely Risk Free</p>
                                    </div>

                                </div>
                            </div>

                            <button className="rounded-xl border border-secondary shadow bg-secondary-100 text-primary shadow mt-5 px-20 py-2 font-pmedium  wow animate__animated animate__fadeInLefts" data--wow-delay="1.2s"> Coming Soon</button>


                        </div>

                    </div>


                </div>
            </section>




            <section className="py-20 bg-secondary-200 px-4 md:px-6 lg:px-40" id="why" >

                <div className="lg:my-20 ">

                    <div className="flex items-center flex-col">
                        <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInLefts">
                            <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                <i className="fa fa-check-circle text-secondary-100"></i></div>
                            <div className="font-pmedium text-sm ml-2 pr-5">
                                Our Advantage
                            </div>

                        </div>


                        <h1 className="font-psemibold text-2xl lg:text-3xl mt-7 wow animate__animated animate__fadeInLefts text-white" data--wow-delay="0.2s">
                            Why Choose <span className="text-primary">MarkMan</span>
                        </h1>

                        <div className="grid grid-cols-12">

                        </div>

                    </div>



                    <div className="grid grid-cols-12 mt-10">
                        <div className="col-span-12 md:col-span-4 mb-10 text-white px-3">
                            <div className="bg-secondary-200 border border-secondary p-10 py-16 rounded-b-3xl shadow-2xl wow animate__animated animate__fadeInUp"  >
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fas fa-rocket text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Instant Transactions
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    MarkMan uses smart contracts to automate payments, ensuring that payouts are made instantly and securely when you reach your earning milestones. No delays, no waiting for manual approvals.
                                </p>
                            </div>
                        </div>



                        <div className="col-span-12 md:col-span-4 text-white px-3 wow animate__animated animate__fadeInUp mb-10" data--wow-delay="0.3s" >
                            <div className="bg-secondary-200 border border-secondary  p-10 py-16 rounded-b-3xl shadow-2xl">
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fa fa-users text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Matrix Structure
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    MarkMan is not just another earning platform. We have integrated a powerful matrix structure with blockchain to unlock a new way of growing your earnings.
                                </p>
                            </div>
                        </div>




                        <div className="col-span-12 md:col-span-4 text-white px-3 wow animate__animated animate__fadeInUp mb-10" data--wow-delay="0.5s">
                            <div className="bg-secondary-200 border border-secondary  p-10 py-16 rounded-b-3xl shadow-2xl">
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fa fa-link text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Blockchain Technology
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    Mark Man leverages the power of blockchain technology to create a secure and transparent environment for your earnings. Transactions are recorded on an immutable ledger, providing trust and safety.
                                </p>
                            </div>
                        </div>


                        <div className="col-span-12 md:col-span-4 text-white px-3 mb-10 wow animate__animated animate__fadeInUp mb-10" data--wow-delay="0.7s">
                            <div className="bg-secondary-200 border border-secondary  p-10 py-16 rounded-b-3xl shadow-2xl">
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fa fa-laptop text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Totally Online
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    All funds on MarkMan are transferred between members, there are no hidden fees and the contract balance is always zero, thus, boosting credibility </p>
                            </div>
                        </div>






                        <div className="col-span-12 md:col-span-4 text-white px-3 mb-10 wow animate__animated animate__fadeInUp" data--wow-delay="0.9s">
                            <div className="bg-secondary-200 border border-secondary  p-10 py-16 rounded-b-3xl shadow-2xl">
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fas fa-shield-alt text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Immutablity
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    Nobody can exclude you from the platform because there is no such function in the contract and the information recorded in the blocks can not be changed </p>
                            </div>
                        </div>






                        <div className="col-span-12 md:col-span-4 text-white px-3 mb-10 wow animate__animated animate__fadeInUp" data--wow-delay="1.1s">
                            <div className="bg-secondary-200 border border-secondary  p-10 py-16 rounded-b-3xl shadow-2xl">
                                <div className="glow-circle rounded-full border-white text-base h-[60px] w-[60px] justify-center flex items-center">
                                    <i className="fas fa-project-diagram text-secondary-100 fa-2x"></i>
                                </div>

                                <h2 className="text-xl font-psemibold mt-5">
                                    Fully Decentralized
                                </h2>

                                <p className="text-gray-100 mt-5 font-plight text-sm">
                                    There are no managers or administrators, there are only the creators who are equal participants in the project like everyone else
                                </p>
                            </div>
                        </div>


                    </div>


                </div>
            </section>

            <section className="py-20 bg-secondary-100 px-4 md:px-6 lg:px-40" id="plan">

                <div className="lg:my-20 ">

                    <div className="flex items-center flex-col">
                        <div className="bg-primary-100 pl-1 py-1 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInLefts">
                            <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                <i className="fa fa-check-circle text-secondary-100"></i></div>
                            <div className="font-pmedium text-sm ml-2 pr-5">
                                Our Plan
                            </div>

                        </div>


                        <h1 className="font-psemibold text-2xl mt-7 wow animate__animated animate__fadeInLefts text-white" data--wow-delay="0.2s">
                            Download <span className="text-primary">MarkMan</span> Plan
                        </h1>

                        <div className="grid grid-cols-12">

                        </div>

                    </div>



                    <div className="grid grid-cols-12 mt-10">
                        <div className="col-span-6 md:col-span-3 text-white px-3 mb-5">
                            <a href="/plan/english.pdf" download><div className="bg-secondary-200 p-3 rounded-3xl shadow-xl wow animate__animated animate__fadeInUp"  >

                                <div className="flex items-center">
                                    <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center">
                                        <i className="fa fa-file-pdf text-secondary-100 fa-x"></i>
                                    </div>

                                    <p className="font-pregular ml-5 text-base">
                                        Download English
                                    </p>
                                </div>

                            </div>
                            </a>
                        </div>

                        <div className="col-span-6 md:col-span-3 text-white px-3 mb-5">
                        <a href="/plan/bangali.pdf" download>
                          <div className="bg-secondary-200 p-3 rounded-3xl shadow-xl wow animate__animated animate__fadeInUp"  >

                                <div className="flex items-center">
                                    <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center">
                                        <i className="fa fa-file-pdf text-secondary-100 fa-x"></i>
                                    </div>

                                    <p className="font-pregular ml-5 text-base">
                                        Download Bangali
                                    </p>
                                </div>

                            </div>
                            </a>
                        </div>

                        <div className="col-span-6 md:col-span-3 text-white px-3 mb-5">
                        <a href="/plan/arabic.pdf" download>
                        <div className="bg-secondary-200 p-3 rounded-3xl shadow-xl wow animate__animated animate__fadeInUp"  >

                                <div className="flex items-center">
                                    <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center">
                                        <i className="fa fa-file-pdf text-secondary-100 fa-x"></i>
                                    </div>

                                    <p className="font-pregular ml-5 text-base">
                                        Download Arabic
                                    </p>
                                </div>

                            </div>
                            </a>
                        </div>


                        <div className="col-span-6 md:col-span-3 text-white px-3 mb-5">
                        <a href="/plan/hindi.pdf" download><div className="bg-secondary-200 p-3 rounded-3xl shadow-xl wow animate__animated animate__fadeInUp"  >

                                <div className="flex items-center">
                                    <div className="glow-circle rounded-full border-white text-base h-[30px] w-[30px] justify-center flex items-center">
                                        <i className="fa fa-file-pdf text-secondary-100 fa-x"></i>
                                    </div>

                                    <p className="font-pregular ml-5 text-base">
                                        Download Hindi
                                    </p>
                                </div>

                            </div>
                            </a>
                        </div>




                    </div>


                </div>
            </section>

        </>

    )
}

export default Home;